import { Injectable } from '@angular/core'
import { SESSION_STORAGE_KEYS } from '@shared/constants'
import { SessionStorageKeysType } from '@shared/types'

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  setItem<T>(key: SessionStorageKeysType, value: T): void {
    sessionStorage.setItem(SESSION_STORAGE_KEYS[key], JSON.stringify(value))
  }

  getItem<T>(key: SessionStorageKeysType): T | null {
    const value = sessionStorage.getItem(SESSION_STORAGE_KEYS[key])
    return value ? JSON.parse(value) : null
  }

  removeItem(key: SessionStorageKeysType): void {
    sessionStorage.removeItem(SESSION_STORAGE_KEYS[key])
  }

  clearAllSession(): void {
    sessionStorage.clear()
  }
}
